export enum InvestigationRole {
	Minister = 24,
	Investigator = 25,
	InvestigationSupervisor = 26,
	InvestigationDirector = 27,
}
